import React from 'react'
import toast from "react-hot-toast";
import AdminLayout from "../layout/AdminLayout";
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { useDeleteProductImageMutation, useGetProductsDetailsQuery, useUploadProductImagesMutation } from '../../redux/api/productsApi';
import { useEffect } from 'react';
import { useRef } from 'react';

const UploadImages = () => {

    const fileInputRef = useRef(null)
    const params = useParams();
    const navigate = useNavigate();

    const [images, setImages] = useState([]);
    const [imagesPreview, setImagesPreview] = useState([]);
    const [uploadedImages, setUploadedImages] = useState([]);

    const [uploadProductImages, { isLoading, error, isSuccess }] = useUploadProductImagesMutation();

    const [deleteProductImage, { isLoading: isDeleteLoading, error: deleteError }] = useDeleteProductImageMutation()

    const { data } = useGetProductsDetailsQuery(params?.id)

    useEffect(() => {
        if (data?.product) {
            setUploadedImages(data?.product?.images)
        }
        if (error) {
            toast.error(error?.data?.message);
        }
        if (deleteError) {
            toast.error(deleteError?.data?.message);
        }
        if (isSuccess) {
            setImagesPreview([])
            toast.success("Images Uploaded");
            navigate("/admin/products");
        }
    }, [data, error, isSuccess, deleteError, navigate])

    const onChange = (e) => {

        const files = Array.from(e.target.files)

        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    setImagesPreview((oldArray) => [...oldArray, reader.result])
                    setImages((oldArray) => [...oldArray, reader.result])
                }
            };
            reader.readAsDataURL(file)
        })

    };

    const handleResetFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }

    const handleImagePreviewDelete = (image) => {
        const filteredIImagesPreview = imagesPreview.filter(
            (img) => img !== image
        )

        setImages(filteredIImagesPreview)
        setImagesPreview(filteredIImagesPreview)
    }

    const submitHandler = (e) => {
        e.preventDefault()
        uploadProductImages({ id: params?.id, body: { images } })
    }

    const deleteImage = (imgId) => {
        deleteProductImage({ id: params?.id, body: { imgId } })
    }

    return (
        <AdminLayout>
            <div>
                <div className="row wrapper mt-0 justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8 mt-5 mt-lg-0 d-flex justify-content-center">
                        <form className="shadow-sm rounded-4 bg-body w-100 p-3 p-md-4" encType="multipart/form-data"
                            onSubmit={submitHandler} style={{ maxWidth: "720px" }}>
                            <h2 className="mb-3 fw-bold text-center" style={{ fontFamily: "Quicksand, sans-serif", color: "#5a2d82" }}>Upload Product Images</h2>

                            <div className="mb-3">
                                <label htmlFor="customFile" className="form-label">Choose Images</label>

                                <div className="custom-file">
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        name="product_images"
                                        className="form-control"
                                        id="customFile"
                                        multiple
                                        onChange={onChange}
                                        onClick={handleResetFileInput}
                                    />
                                </div>
                                {imagesPreview?.length > 0 && (
                                    <div className="new-images my-4">
                                        <p className="text-warning">New Images:</p>
                                        <div className="row g-3 mt-2">
                                            {imagesPreview?.map((img, idx) => (
                                                <div key={`new-${idx}`} className="col-6 col-sm-4 col-md-3">
                                                    <div className="card h-100 d-flex">
                                                        <img
                                                            src={img}
                                                            alt="New preview"
                                                            className="card-img-top p-2 img-fluid"
                                                            style={{ width: "100%", height: "100px", objectFit: "contain" }}
                                                        />
                                                        <button
                                                            style={{ backgroundColor: "#dc3545", borderColor: "#dc3545" }}
                                                            type="button"
                                                            className="btn btn-danger cross-button mt-1 py-0"
                                                            onClick={() => handleImagePreviewDelete(img)}
                                                        >
                                                            <i className="fa fa-times"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {uploadedImages?.length > 0 && (
                                    <div className="uploaded-images my-4">
                                        <p className="text-success">Product Uploaded Images:</p>
                                        <div className="row g-3 mt-2">
                                            {uploadedImages?.map((img, idx) => (
                                                <div key={`upl-${idx}`} className="col-6 col-sm-4 col-md-3">
                                                    <div className="card h-100 d-flex">
                                                        <img
                                                            src={img?.url}
                                                            alt="Uploaded"
                                                            className="card-img-top p-2 img-fluid"
                                                            style={{ width: "100%", height: "100px", objectFit: "contain", background: "#ffffffff" }}
                                                        />
                                                        <button
                                                            style={{ backgroundColor: "#dc3545", borderColor: "#dc3545" }}
                                                            className="btn btn-danger cross-button mt-1 py-0"
                                                            type="button"
                                                            disabled={isLoading || isDeleteLoading}
                                                            onClick={() => deleteImage(img?.public_id)}
                                                        >
                                                            <i className="fa fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}


                            </div>

                            <button id="register_button" type="submit" className="btn update-btn w-100 fw-semibold" disabled={isLoading || isDeleteLoading}>
                                {isLoading ? "UPLOADING..." : "Upload"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </AdminLayout>
    )
}

export default UploadImages
